export default function reducer(state={
		payments: [],
		order: [],
		fetching: false,
		fetched: false,
		error: null
	}, action) {

	switch (action.type) {
		case "FETCH_PAYMENTS": {
			return {...state, fetching: true}
		}
		case "FETCH_PAYMENTS_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "FETCH_PAYMENTS_FULFILLED": {
			return {...state, fetching: false, fetched: true, payments: action.payload.payments}
		}
		// case "FETCH_ALL_PAYMENTS": {
		// 	return {...state, fetching: true, fetched: false, payments: action.payload.data}
		// }
		case "CREATE_PAYMENT": {
			return {...state, fetching: true}
		}
		case "CREATE_PAYMENT_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "CREATE_PAYMENT_FULFILLED": {
			return {...state, fetching: false, fetched: true, payments: action.payload.payments, order: action.payload.order}
		}
		case "UPDATE_PAYMENT": {
			return {...state, fetching: true}
		}
		case "UPDATE_PAYMENT_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "UPDATE_PAYMENT_FULFILLED": {
			return {...state, fetching: false, fetched: true, payments: action.payload.payments, order: action.payload.order}
		}
		case "DELETE_PAYMENT": {
			return {...state, fetching: true}
		}
		case "DELETE_PAYMENT_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "DELETE_PAYMENT_FULFILLED": {
			return {...state, fetching: false, fetched: true, payments: action.payload.payments, order: action.payload.order}
		}
		default: {
        	break;
		}
	}

	return state
}